import { BillingOverviewRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/overview')({
  component: BillingOverviewRoute,
});
